import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, NBAAuthService } from '@fgb/core';


@Component({
  selector: 'fgb-nba-callback',
  templateUrl: './nba-callback.component.html',
  styleUrl: './nba-callback.component.scss',
})
export class NbaCallbackComponent implements OnInit {
  constructor(
    private nbaAuthService: NBAAuthService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      // already logged in
      this.router.navigate(['/']);
    } else {
      // log through a token
      this.authenticateCode();
    }
  }

  /**
   * call to athenticate JWT
   * if failed response will return
   * user to login page.
   */
  authenticateCode() {
    let nbaCode = this.getProviderCodeToken('code');
    this.nbaAuthService
      .validateCode(nbaCode)
      .toPromise()
      .catch(() => {
        this.router.navigate(['/login']);
      });
  }

  /**
   * Get a query string parameter without case sensitivity.
   * @param parameter the parameter that you require the information for
   */
  getProviderCodeToken(parameter: string): string {
    const url = window.location.href;
    let paramValue;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(parameter);
    }

    if (paramValue) {
      return paramValue;
    }
    return '';
  }
}
